// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__3iTQH","input_img":"Search_input_img__BsriQ","big":"Search_big__2kDp0"};